<template>
    <div>
        <vs-input type="file" class="input-file" ref="file" name="file" @change="select" />
        <vs-row>
            <vs-col class="md:w-9/12 w-full">
                <vs-input class="w-full"
                          :label="label"
                          v-model="filename"
                          :readonly="true"
                />
            </vs-col>
            <vs-col class="md:w-3/12 w-full">
                <vs-button class="ml-6 mt-6" @click="open">{{ buttonText }}</vs-button>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
  export default {
    name: "InputFile",
    props: {
      value: {},
      label: {
        type: String,
        required: true,
      },
      buttonText: {
        type: String,
        required: true,
      },
      fileTypes: {
        type: Array,
        required: false,
      },
      /**
       * This should be in MB
       */
      filesize: {
        type: [Number, String],
        required: false,
      }
    },
    data() {
      return {
        file: null,
        input: null
     }
    },
    computed: {
      filename() {
        if (!this.file) {
          return '';
        }

        return this.file.name;
      }
    },
    mounted() {
      this.input = this.$el.querySelector('input[type=file]');
    },
    watch: {
      file (val) {
        this.$emit('input', val);
      }
    },
    methods: {
      open() {
        const event = new MouseEvent('click', {
          'view': window,
          'bubbles': true,
          'cancelable': true
        });
        this.input.dispatchEvent(event)
      },
      select() {
        const hasExtension = (fileName, exts) => {
          return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(fileName);
        }

        this.file = null;
        for (let file of this.input.files) {
          if (!this.fileTypes) {
            this.file = file;
            return;
          }

          let accepted = hasExtension(file.name, this.fileTypes);
          if (!accepted) {
            const message = this.$t('InvalidFileType'); // + ' - Only ' + this.fileTypes.join(', ') + ' are allowed';
            this.$emit('error', message);
            return;
          }

          if (this.filesize) {
            const sizeInMb = file.size / 1024 / 1024;

            if (sizeInMb > parseInt(this.filesize)) {
              this.$emit('error', `${this.$t('InvalidFileSize')} ${this.filesize}MB`);
              return;
            }
          }

          this.file = file;
        }
      },

    }
  }
</script>

<style lang="scss">
    .input-file {
        display: none;
    }
</style>
